import React, { useContext, useEffect } from "react";
import { Context } from "../context/Context";

import "./MenuDetail.css";
import RoomsList from "../components/RoomsList";
import Settings from "../components/Settings";
import PlanningMenu from "../components/PlanningMenu";

const MenuDetail = () => {
  const { openDetailMenu, setOpenDetailMenu, page } = useContext(Context);

  useEffect(() => {
    if (openDetailMenu) {
      document.body.classList.add("menu-detail-open");
      document.body.classList.remove("menu-detail-closed");
    } else {
      document.body.classList.add("menu-detail-closed");
      document.body.classList.remove("menu-detail-open");
    }
  }, [openDetailMenu]);

  const getPageTitle = () => {
    if (page.slug == "home") return "اتاق‌ها";
    if (page.slug == "planning/scenario" || page.slug == "planning/scenario-list") return "سناریوها";
    if (page.slug == "planning/schedule" || page.slug == "planning") return "زمان‌بندی";
    if (page.slug == "settings") return "تنظیمات عمومی";
    if (page.slug == "devices") return "دستگاه‌ها";
    if (page.slug == "backup-management") return "مدیریت پشتیبان";
    if (page.slug == "about-us") return "درباره ما";
    if (page.slug == "help") return "راهنما";
    return "منو";
  };

  return (
    <>
      {/* Toggle Button - Always visible, outside the menu */}
      <div className="menu-detail-toggle">
        <i
          className={openDetailMenu ? "bx bx-chevron-right" : "bx bx-chevron-left"}
          onClick={() => setOpenDetailMenu(!openDetailMenu)}
          title={openDetailMenu ? "بستن منو" : "باز کردن منو"}
        ></i>
      </div>

      {/* Detail Menu */}
      <aside 
        id="menu-detail" 
        className={`d-none d-lg-block bg-menu-theme ${!openDetailMenu ? "menu-closed" : ""}`}
      >
        <div className="menu-detail-header">
          <h4>{getPageTitle()}</h4>
        </div>

        {page.slug == "home" ? <RoomsList /> : null}
        {page.slug == "planning/scenario" ||
        page.slug == "planning/scenario-list" ||
        page.slug == "planning/schedule" ||
        page.slug == "planning" ? (
          <PlanningMenu />
        ) : null}
        {page.slug == "settings" ||
        page.slug == "backup-management" ||
        page.slug == "about-us" ||
        page.slug == "help" ? (
          <Settings />
        ) : null}
      </aside>
    </>
  );
};

export default MenuDetail;